export default {
    install(app) {

        app.config.globalProperties.$vars = () => {
        
            return {
                'errorWs' : 'Error de servicio, intente más tarde',
                'successWs' : 'Éxito',
                'api_key' : 'fb37824b06dc11eda66218c04d3d22a9',
                // vistas de cuentas
                'viewCuenta' : {
                    10 : 'detalleCuentaFisica',
                    20 : 'detalleCuentaMoral',
                    30 : 'detalleCuentaFisicaAE'
                },
                // clasificacion de cuentas
                'tipo_persona_select': [
                    { 'value': '0', 'text': 'Todas las cuentas' },
                    { 'value': '10', 'text': 'Persona Física' },
                    { 'value': '20', 'text': 'Persona Moral' },
                    { 'value': '30', 'text': 'Física con Actividad Empresarial' }
                ],
                'tipo_persona' : {
                    '10'    : 'Persona Física',
                    '20'    : 'Persona Moral',
                    '30'    : 'Física con Actividad Empresarial'
                },
                'tipo_cuenta' : {
                    '10'    : 'Cuenta de débito',
                    '20'    : 'Cuenta de crédito',
                    '30'    : 'Cuenta de caja'
                },
                'mediosPagosComponentes' : [
                    "medioPagoAsp",
                    "medioPagoBankaool",
                    "medioPagoStp",
                    "medioPagoCajaAhorro",
                    "medioPagoSalaryOnDemand",
                    "medioPagoServicios",
                    "medioPagoSantander",
                    "medioPagoCuentasLocales",
                    "medioPagoPayCash",
                    "medioPagoInntec",
                    "medioPagoMoneyGiver",
                    "medioPagoPomelo",
                    "medioPagoPs",
                    "medioPagoStripe",
                    "medioPagoOpenPay",
                    "medioPagoOpm"
                ],
                'mediosPagosComponentesPs' : [
                    "medioPagoPs",
                    // "medioPagoServicios"
                ],
                'mediosPagosComponentesUniques' : [
                    "medioPagoTransferenciasLocalesEmpresariales",
                    "medioPagoInntec",
                    "medioPagoMaanyuba",
                    "medioPagoCopaymentVisa",
                    "medioPagoStripe",
                    "medioPagoOpenPay",
                    "medioPagoPs",
                    "medioPagoServicios"
                ],
                // paycash
                'items_tipo_paycash' : [
                    // {'value' : '', 'text' : 'Seleccionar tipo de referencia'},
                    {'value' : 1 , 'text' : 'Única'},
                    {'value' : 2 , 'text' : 'Recurrente'},
                ],
                // estatus tarjeta
                'activo_tarjeta' : 1,
                'bloqueada_tarjeta' : 2,
                'estatus_tarjetas' : {
                    '1'    : 'Activa',
                    '2'    : 'Bloquear'
                },
                // estatus Cuenta
                'estatus' : {
                    '10'    : 'Activa',
                    '20'    : 'Bloqueada',
                    '30'    : 'Inactiva'
                },
                // cuenta medio pago
                'activo_cmp' : 10,
                'inactivo_cmp' : -10,
                'por_activar_cmp' : -20,
                'estatus_cuenta_medio_pago' : {
                    '10'    : 'Activo',
                    '-10'    : 'Inactivo',
                    '-20'    : 'Por Activar'
                },
                // transacciones y tipo de transacción
                'tipoTransaccion' : {
                    '20' : 'Cargo',
                    '10' : 'Abono',
                    '30' : 'Comisión',
                    '40' : 'Devolución',
                    '340' : 'No Procesado',
                    // '90' : 'Abono de Salida (Cashback)',
                    // '100' : 'Abono de Entrada (Cashback)',
                    // '110' : 'Interés Alcancía',
                    // '120' : 'Aportación Alcancía',
                    // '130' : 'Retiro Alcancía',
                },
                'selectMovimiento' : [
                    { 'value': "", 'text': 'Todos' },
                    { 'value': "10", 'text': 'Abonos' },
                    { 'value': "20", 'text': 'Cargos' },
                    { 'value': "30", 'text': 'Comisión' },
                    { 'value': "40", 'text': 'Devolución' },
                    { 'value': "340", 'text': 'No Procesado' },
                    // { 'value': "90", 'text': 'Abono de Salida (Cashback)' },
                    // { 'value': "100", 'text':'Abono de Entrada (Cashback)' },
                    // { 'value': "110", 'text': 'Interés Alcancía' },
                    // { 'value': "120", 'text': 'Aportación Alcancía' },
                    // { 'value': "130", 'text': 'Retiro Alcancía' },
                ],
                'selectMovimientoComprobante' : [
                    { 'value': "0", 'text': 'Todos' },
                    { 'value': "10", 'text': 'Abonos' },
                    { 'value': "20", 'text': 'Cargos' },
                ],
                // transacciones pendietnes
                'estatusPendiente' : {
                    '10' : 'Por Procesar',
                    '20' : 'Procesada',
                    '30' : 'Procesando',
                    '40' : 'Sin Autorizar',
                    '50' : 'Eliminada',
                    '60' : 'Dispersada a Money Giver',
                    // errores
                    '-10' : 'No encontré cuenta origen',
                    '-20' : 'No existen configuraciones del medio de pago',
                    '-30' : 'No existe clabe a asociar',
                    '-40' : 'Saldo insuficiente',
                    '-50' : 'No hay producto de ahorro empresa',
                    '-60' : 'Error al enviar el banco',
                    '-70' : 'Sin soporte medio de pago',
                    '-80' : 'No se encontró cuenta destino',
                    '-100' : 'ERROR en Bankaool',
                    '-120' : 'ERROR al procesar Pago de Servicio',
                    '-130' : 'Duplicado',
                    '-140' : 'Error de Ejecución',
                    '-150' : 'Error de PreEjecución',
                },
                // ordenes lotes
                'estatusOrdenesLotes' : {
                    '10' : 'En Proceso',
                    '20' : 'Generado',
                    '30' : 'Error',
                    '40' : 'Generando',
                    '80' : 'Caducado'
                },
                'estatusTransaccionesOrdenesLotes' : {
                    '0' : 'Todos',
                    '10' : 'Abonos',
                    '20' : 'Cargos',
                },
            }
        };

        app.config.globalProperties.$bancos = [
            {'value' : '', 'text' : 'Seleccione Banco'},
            {'value' : 'ABC CAPITAL', 'text' : 'ABC CAPITAL'},
            {'value' : 'ACTINVER', 'text' : 'ACTINVER'},
            {'value' : 'AFIRME', 'text' : 'AFIRME'},
            {'value' : 'ARCUS', 'text' : 'ARCUS'},
            {'value' : 'ASP INTEGRA OPC', 'text' : 'ASP INTEGRA OPC'},
            {'value' : 'AUTOFIN', 'text' : 'AUTOFIN'},
            {'value' : 'AZTECA', 'text' : 'AZTECA'},
            {'value' : 'BAJIO', 'text' : 'BAJIO'},
            {'value' : 'BANAMEX', 'text' : 'BANAMEX'},
            {'value' : 'BANAMEX2', 'text' : 'BANAMEX2'},
            {'value' : 'BANCO FINTERRA', 'text' : 'BANCO FINTERRA'},
            {'value' : 'BANCO S3', 'text' : 'BANCO S3'},
            {'value' : 'BANCOMEXT', 'text' : 'BANCOMEXT'},
            {'value' : 'BANCOPPEL', 'text' : 'BANCOPPEL'},
            {'value' : 'BANCREA', 'text' : 'BANCREA'},
            {'value' : 'BANJERCITO', 'text' : 'BANJERCITO'},
            {'value' : 'BANK OF AMERICA', 'text' : 'BANK OF AMERICA'},
            {'value' : 'BANKAOOL', 'text' : 'BANKAOOL'},
            {'value' : 'BANOBRAS', 'text' : 'BANOBRAS'},
            {'value' : 'BANORTE', 'text' : 'BANORTE'},
            {'value' : 'BANREGIO', 'text' : 'BANREGIO'},
            {'value' : 'BANSEFI', 'text' : 'BANSEFI'},
            {'value' : 'BANSI', 'text' : 'BANSI'},
            {'value' : 'BARCLAYS', 'text' : 'BARCLAYS'},
            {'value' : 'BBASE', 'text' : 'BBASE'},
            {'value' : 'BBVA MEXICO', 'text' : 'BBVA MEXICO'},
            {'value' : 'BMONEX', 'text' : 'BMONEX'},
            {'value' : 'CAJA POP MEXICA', 'text' : 'CAJA POP MEXICA'},
            {'value' : 'CAJA TELEFONIST', 'text' : 'CAJA TELEFONIST'},
            {'value' : 'CB INTERCAM', 'text' : 'CB INTERCAM'},
            {'value' : 'CI BOLSA', 'text' : 'CI BOLSA'},
            {'value' : 'CIBANCO', 'text' : 'CIBANCO'},
            {'value' : 'COMPARTAMOS', 'text' : 'COMPARTAMOS'},
            {'value' : 'CONSUBANCO', 'text' : 'CONSUBANCO'},
            {'value' : 'CREDICAPITAL', 'text' : 'CREDICAPITAL'},
            {'value' : 'CREDIT SUISSE', 'text' : 'CREDIT SUISSE'},
            {'value' : 'CRISTOBAL COLON', 'text' : 'CRISTOBAL COLON'},
            {'value' : 'CoDi Valida', 'text' : 'CoDi Valida'},
            {'value' : 'DONDE', 'text' : 'DONDE'},
            {'value' : 'EVERCORE', 'text' : 'EVERCORE'},
            {'value' : 'FINAMEX', 'text' : 'FINAMEX'},
            {'value' : 'FINCOMUN', 'text' : 'FINCOMUN'},
            {'value' : 'FOMPED', 'text' : 'FOMPED'},
            {'value' : 'FONDO (FIRA)', 'text' : 'FONDO (FIRA)'},
            {'value' : 'GBM', 'text' : 'GBM'},
            {'value' : 'HIPOTECARIA FED', 'text' : 'HIPOTECARIA FED'},
            {'value' : 'HSBC', 'text' : 'HSBC'},
            {'value' : 'ICBC', 'text' : 'ICBC'},
            {'value' : 'INBURSA', 'text' : 'INBURSA'},
            {'value' : 'INDEVAL', 'text' : 'INDEVAL'},
            {'value' : 'INMOBILIARIO', 'text' : 'INMOBILIARIO'},
            {'value' : 'INTERCAM BANCO', 'text' : 'INTERCAM BANCO'},
            {'value' : 'INVERCAP', 'text' : 'INVERCAP'},
            {'value' : 'INVEX', 'text' : 'INVEX'},
            {'value' : 'JP MORGAN', 'text' : 'JP MORGAN'},
            {'value' : 'KUSPIT', 'text' : 'KUSPIT'},
            {'value' : 'LIBERTAD', 'text' : 'LIBERTAD'},
            {'value' : 'MASARI', 'text' : 'MASARI'},
            {'value' : 'MIFEL', 'text' : 'MIFEL'},
            {'value' : 'MIZUHO BANK', 'text' : 'MIZUHO BANK'},
            {'value' : 'MONEXCB', 'text' : 'MONEXCB'},
            {'value' : 'MUFG', 'text' : 'MUFG'},
            {'value' : 'MULTIVA BANCO', 'text' : 'MULTIVA BANCO'},
            {'value' : 'MULTIVA CBOLSA', 'text' : 'MULTIVA CBOLSA'},
            {'value' : 'NAFIN', 'text' : 'NAFIN'},
            {'value' : 'NU MEXICO', 'text' : 'NU MEXICO'},
            {'value' : 'NVIO', 'text' : 'NVIO'},
            {'value' : 'PAGATODO', 'text' : 'PAGATODO'},
            {'value' : 'PROFUTURO', 'text' : 'PROFUTURO'},
            {'value' : 'REFORMA', 'text' : 'REFORMA'},
            {'value' : 'SABADELL', 'text' : 'SABADELL'},
            {'value' : 'SANTANDER', 'text' : 'SANTANDER'},
            {'value' : 'SCOTIABANK', 'text' : 'SCOTIABANK'},
            {'value' : 'SHINHAN', 'text' : 'SHINHAN'},
            {'value' : 'STP', 'text' : 'STP'},
            {'value' : 'TACTIV CB', 'text' : 'TACTIV CB'},
            {'value' : 'UNAGRA', 'text' : 'UNAGRA'},
            {'value' : 'VALMEX', 'text' : 'VALMEX'},
            {'value' : 'VALUE', 'text' : 'VALUE'},
            {'value' : 'VE POR MAS', 'text' : 'VE POR MAS'},
            {'value' : 'VECTOR', 'text' : 'VECTOR'},
            {'value' : 'VOLKSWAGEN', 'text' : 'VOLKSWAGEN'}
        ]
        app.config.globalProperties.$bancos_new = [
            {'value' : '40138', 'text' : 'ABC CAPITAL'},
            {'value' : '40133', 'text' : 'ACTINVER'},
            {'value' : '40062', 'text' : 'AFIRME'},
            {'value' : '90706', 'text' : 'ARCUS'},
            {'value' : '90659', 'text' : 'ASP INTEGRA OPC'},
            {'value' : '40128', 'text' : 'AUTOFIN'},
            {'value' : '40127', 'text' : 'AZTECA'},
            {'value' : '40030', 'text' : 'BAJIO'},
            {'value' : '40002', 'text' : 'BANAMEX'},
            {'value' : '91802', 'text' : 'BANAMEX2 '},
            {'value' : '40154', 'text' : 'BANCO FINTERRA'},
            {'value' : '40160', 'text' : 'BANCO S3'},
            {'value' : '37006', 'text' : 'BANCOMEXT'},
            {'value' : '40137', 'text' : 'BANCOPPEL'},
            {'value' : '40152', 'text' : 'BANCREA'},
            {'value' : '37019', 'text' : 'BANJERCITO'},
            {'value' : '40106', 'text' : 'BANK OF AMERICA'},
            {'value' : '40147', 'text' : 'BANKAOOL'},
            {'value' : '37009', 'text' : 'BANOBRAS'},
            {'value' : '40072', 'text' : 'BANORTE'},
            {'value' : '40058', 'text' : 'BANREGIO'},
            {'value' : '37166', 'text' : 'BANSEFI'},
            {'value' : '40060', 'text' : 'BANSI'},
            {'value' : '40129', 'text' : 'BARCLAYS'},
            {'value' : '40145', 'text' : 'BBASE'},
            {'value' : '40012', 'text' : 'BBVA MEXICO'},
            {'value' : '40112', 'text' : 'BMONEX'},
            {'value' : '90677', 'text' : 'CAJA POP MEXICA'},
            {'value' : '90683', 'text' : 'CAJA TELEFONIST'},

            {'value' : '90631', 'text' : 'CI BOLSA'},

            {'value' : '40130', 'text' : 'COMPARTAMOS'},
            {'value' : '40140', 'text' : 'CONSUBANCO'},
            {'value' : '90652', 'text' : 'CREDICAPITAL'},
            {'value' : '40126', 'text' : 'CREDIT SUISSE'},
            {'value' : '90680', 'text' : 'CRISTOBAL COLON'},
            {'value' : '90903', 'text' : 'CoDi Valida'},
            {'value' : '40151', 'text' : 'DONDE'},
            {'value' : '90648', 'text' : 'EVERCORE'},
            {'value' : '90616', 'text' : 'FINAMEX'},
            {'value' : '90634', 'text' : 'FINCOMUN'},
            {'value' : '90689', 'text' : 'FOMPED'},
            {'value' : '90699', 'text' : 'FONDEADORA'},
            {'value' : '90685', 'text' : 'FONDO (FIRA)'},
            {'value' : '90601', 'text' : 'GBM'},
            {'value' : '37168', 'text' : 'HIPOTECARIA FED'},
            {'value' : '40021', 'text' : 'HSBC'},
            {'value' : '40155', 'text' : 'ICBC'},
            {'value' : '40036', 'text' : 'INBURSA'},
            {'value' : '90902', 'text' : 'INDEVAL'},
            {'value' : '40150', 'text' : 'INMOBILIARIO'},
            {'value' : '40136', 'text' : 'INTERCAM BANCO'},
            {'value' : '90686', 'text' : 'INVERCAP'},
            {'value' : '40059', 'text' : 'INVEX'},
            {'value' : '40110', 'text' : 'JP MORGAN'},
            {'value' : '90661', 'text' : 'KLAR'},
            {'value' : '90653', 'text' : 'KUSPIT'},
            {'value' : '90670', 'text' : 'LIBERTAD'},
            {'value' : '90602', 'text' : 'MASARI'},
            {'value' : '90722', 'text' : 'MERCADO PAGO'},
            {'value' : '40042', 'text' : 'MIFEL'},
            {'value' : '40158', 'text' : 'MIZUHO BANK'},
            {'value' : '90600', 'text' : 'MONEXCB'},
            {'value' : '40108', 'text' : 'MUFG'},
            {'value' : '40132', 'text' : 'MULTIVA BANCO'},
            {'value' : '90613', 'text' : 'MULTIVA CBOLSA'},
            {'value' : '37135', 'text' : 'NAFIN'},
            {'value' : '90638', 'text' : 'NU MEXICO'},
            {'value' : '90710', 'text' : 'NVIO'},
            {'value' : '40148', 'text' : 'PAGATODO'},
            {'value' : '90620', 'text' : 'PROFUTURO'},
            {'value' : '90642', 'text' : 'REFORMA'},
            {'value' : '40156', 'text' : 'SABADELL'},
            {'value' : '40014', 'text' : 'SANTANDER'},
            {'value' : '40044', 'text' : 'SCOTIABANK'},
            {'value' : '40157', 'text' : 'SHINHAN'},
            {'value' : '90646', 'text' : 'STP'},
            {'value' : '90728', 'text' : 'SPIN BY OXXO'},
            {'value' : '90684', 'text' : 'TRANSFER'},
            {'value' : '90656', 'text' : 'UNAGRA'},
            {'value' : '90617', 'text' : 'VALMEX'},
            {'value' : '90605', 'text' : 'VALUE'},
            {'value' : '40113', 'text' : 'VE POR MAS'},

            {'value' : '40141', 'text' : 'VOLKSWAGEN'},
        ]

        app.config.globalProperties.$permisos = {
            'enviar_una_tx'                     : true, // Transferencias 1-1 (mostrar pestaña de transferencias cuando al menos un permiso este activo)
            'importar_transacciones'            : true, // Transferencias masivas (mostrar pestaña de transferencias cuando al menos un permiso este activo)
            'aprobar_transacciones'             : true, // Módulo de aprobar transacciones
            'eliminar_transacciones'            : true, // Eliminar transacciones 
            'seguimiento_tx'                    : true, // visualiza módulo de seguimiento de transferencias
            'generar_comprobante_transacciones' : true, // visualiza comprobantes de transacciones en movimientos
            'permiso_transferencias_transito'   : true, // visualiza movimientos en transito
            'generar_estado_cuenta'             : true, // Generar estado de cuenta (Botón)
            'tarjetas_vinculadas'               : true, // Generar estado de cuenta (Botón)
            'generar-comprobante-lote'          : true, // Generar comprobantes por lotes y periodo (Botón)
            'cobranza'                          : true, // Visualiza cobranza (pestaña)
            'gestion_cobranza_referenciada'     : true, // Visualiza cobranza referenciada y detalle (Botón)
            'edo_cuenta_cobranza_referenciada'  : true, // Genera estado de cuenta (sólo aplica en detalle de cobranza)
            'lotes_cobranza_referenciada'       : true, // Genera comprobantes por lote (sólo aplica en detalle de cobranza)
            'estados_cuenta_segundo_plano'      : true, // Listado de estados de cuenta generados en segundo plano
            'reporte_cuenta'                    : true, // Reporte de transacciones
        }

    }
}